import api from './api';
export const rmaService = {
    createRequest(requestData) {
        return api.post('/api/rma/request', requestData);
    },
    getRequestStatus(rmaNumber) {
        return api.get(`/api/rma/status/${rmaNumber}`);
    },
    getRequests(params = {}) {
        return api.get('/api/rma/requests', { params });
    },
    getRequest(id) {
        return api.get(`/api/rma/requests/${id}`);
    },
    updateRequestStatus(id, data) {
        return api.put(`/api/rma/requests/${id}/status`, data);
    },
    deleteRequest(id) {
        return api.delete(`/api/rma/requests/${id}`);
    },
    getStats() {
        return api.get('/api/rma/stats');
    },
};
